import { Amplify } from "aws-amplify";
import { useAuthContext } from "./contexts/AuthContext";
// import config from  './graphql/amplify_outputs.json';
import configDev from './graphql/amplify_outputs_dev_sandbox.json';
import configProd from './graphql/amplify_outputs_prod.json';
import Client from "./appolo/Client";
import ReactGA from "react-ga4";
import { BrowserRouter, Routes, Route, HashRouter as Router, useNavigate } from "react-router-dom";
// PROTECTED
import ProtectedRoute from "./ProtectedRoute";
// LAYOUT
import Layout from "./pages/Layout";
// FREE
import Home from "./pages/Home";
import DetailView from "./pages/DetailScreen";
import Help from "./pages/HelpScreen";
import Blog from "./pages/Blog";
import SignIn from "./pages/AuthScreen/SignInScreen";
import SignUp from "./pages/AuthScreen/SignUpScreen";
import ConfirmEmail from "./pages/AuthScreen/ConfirmEmailScreen";
import ForgotPassword from "./pages/AuthScreen/ForgotPasswordScreen";
import NewPassword from "./pages/AuthScreen/NewPasswordScreen";
// USER
import DashboardView from "./pages/HomeScreen";
import CreateWorkers from "./pages/UserScreen/CreateWorkersView";
import UsersView from "./pages/UserScreen/UsersView";
import UserView from "./pages/UserScreen/UserView";
import Table from "./pages/TableScreen";
import ExcelImport from "./pages/TableScreen/SpreadsheetScreen";
import TableOpenShift from "./pages/TableScreen/TableOpenScreen";
import ExcelImportOpenShift from "./pages/TableScreen/SpreadsheetOpenScreen";
import ProfileView from "./pages/UserScreen/ProfileView";
import EditProfileView from "./pages/EditProfileScreen";
import Suspended from './pages/UserScreen/SuspendedScreen';
import CompanySuspended from './pages/UserScreen/SuspendedCompanyScreen';
// OPEN SHIFT
import OpenShiftsByUserView from "./pages/OpenShiftScreen/OpenShiftsByUserView";
import OpenPublicShiftsByUserView from "./pages/OpenShiftScreen/OpenPublicShiftsByUserView";
// SHIFT
import ShiftsByUserView from "./pages/ShiftScreen/ShiftsByUserView";
import ShiftView from "./pages/ShiftScreen/ShiftView";
import UsersByShiftsView from "./pages/ShiftScreen/UsersByShiftView";
// AGENDA
import SchedulerView from "./pages/SchedulerScreen/SchedulerView";
import OpenSchedulerView from "./pages/OpenSchedulerScreen/OpenSchedulerView";
import AgendaView from "./pages/AgendaScreen/AgendaView";
import AgendaManagerView from "./pages/AgendaManagerScreen/AgendaManagerView";
import CreateCompanyView from "./pages/CompanyScreen/CreateCompanyView";
// MOBILE
import SchedulerMobileView from "./pages/SchedulerScreen/SchedulerMobileView";
import OpenSchedulerMobileView from "./pages/OpenSchedulerScreen/OpenSchedulerMobileView";
// POST
import PostsView from "./pages/PostScreen";
import PostsByUserView from "./pages/PostScreen/PostByUserScreen";
// DOCUMENT
import UserDocumentsView from "./pages/DocumentScreen";
import DocumentsView from "./pages/DocumentScreen/DocumentByComScreen";
// REQUEST
  // swaps
import CreateRequestSwapView from './pages/RequestScreen/SwapScreen/CreateRequestSwapScreen';
import RequestSwapsView from './pages/RequestScreen/SwapScreen/RequestSwapsScreen';
import RequestUserSwapsView from './pages/RequestScreen/SwapScreen/RequestUserSwapsScreen';
import RequestSuggestedUserSwapsView from './pages/RequestScreen/SwapScreen/RequestSuggestedUserSwapsScreen';
  // leaves
import CreateLeaveRequestSwapsView from './pages/RequestScreen/LeavesScreen/CreateLeaveRequestScreen';
import RequestLeavesView from './pages/RequestScreen/LeavesScreen/RequestLeavesScreen';
import RequestSuggestedUserLeavesView from './pages/RequestScreen/LeavesScreen/RequestSuggestedUserLeavesScreen';
// MAPS
import MapView from "./pages/MapScreen";
// COMPANY
import CompanyView from "./pages/CompanyScreen"
// BILLING
import BillingView from "./pages/StripeScreen/BillingScreen";
import StripeBillingView from "./pages/StripeScreen";
import StripeSuccessView from "./pages/StripeScreen/StripeSuccessScreen";
import StripeCancelView from "./pages/StripeScreen/StripeCancelScreen";
import FreePlanView from "./pages/StripeScreen/FreePlanView";
// import BraintreeView from "./pages/BraintreeScreen/BraintreeView";
// import BraintreeBillingView from "./pages/CompanyScreen/BraintreePayment"; // to add paypal
// import BraintreeDropInView from "./pages/CompanyScreen/BraintreeDropIn";

import NotFound from "./pages/Errors/NotFound";
import Error400 from "./pages/Errors/Error400";
import ForbiddenError from "./pages/Errors/ForbiddenError";
import ServerError from "./pages/Errors/ServerError";

import axios from "axios";
import { useEffect, useState } from "react";
import AnalyticsTracker from "./pages/services/AnalyticsTracker";
// import { initializeApp } from "firebase/app";
import { firebaseApp } from "./firebase-config";
import firebase from "firebase/app";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { Toast, ToastContainer, Button } from 'react-bootstrap';
import useUpdateNotifier from './hooks/useUpdateNotifier';
import Terms from "./pages/Terms";
import DocumentByWorkerScreen from "./pages/DocumentScreen/DocumentByWorkerScreen";

const env = process.env.REACT_APP_ENV;

Amplify.configure(env === "prod" ? configProd : configDev);

const TRACKING_ID = "G-1CTRFGFLBB";

// USE THIS WHEN NOT HTTPS OR LOCALHOST OR IOS SIMULATOR & IOS DEVICES (WEBVIEW)
let messaging: ReturnType<typeof getMessaging> | null = null;
let analytics: ReturnType<typeof getAnalytics> | null = null;
const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
// @ts-ignore
const isRNWebView = !!(window.ReactNativeWebView);

if (!(isIOS && isRNWebView) && 'serviceWorker' in navigator) {
  // if (!isMacOSApp) {
    // alert('test: ' + window.webkit?.messageHandlers);
    messaging = getMessaging(firebaseApp);
    analytics = getAnalytics(firebaseApp);
  // } else {
  //   messaging = null;
  // }
}

// Extend Window interface to declare 
// onTokenReceived, onNativeNotificationReceived & onNativeNotificationLinkReceived
// with webkit & chrome for platform detection
declare global {
  interface Window {
    onTokenReceived?: (token: string) => void;
    onNativeNotificationReceived?: (data: any) => void;
    onNativeNotificationLinkReceived?: (data: any) => void;
    webkit?: {
      messageHandlers?: any;
    };
    chrome?: {
      webview?: {
        hostObjects?: { 
          schedulumHost: any
        }
      }
    }
  }
}

const isWindowApp = window.chrome?.webview?.hostObjects?.schedulumHost;

const isMacOSApp = window.webkit?.messageHandlers;


// if (!(/iPhone|iPad|iPod/i.test(navigator.userAgent))) {
//   if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
//     const messaging = getMessaging(firebaseApp);
//     const analytics = getAnalytics(firebaseApp);
//     // if (!(/iPhone|iPad|iPod/i.test(navigator.userAgent))) {
//     // }
//   }
// } else {
//   const messaging = getMessaging(firebaseApp);
//   const analytics = getAnalytics(firebaseApp);
// }

const subscribeToFCMByBackend = (token: string, topic: string[]) => {
  fetch("/api/FCM/subscribe-to-topic", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      token: token,
      topic
    })
  });
}

const subscribeToTopics = async () => {
  const FCMToken = localStorage.getItem("FCMToken");
  if (FCMToken) {
    const globalTopic = 'global';
    const postsTopic = 'posts';
    
    try {
      const alreadySubscribed = localStorage.getItem('subscribedTopics');
      const subscribed = alreadySubscribed ? JSON.parse(alreadySubscribed) : [];

      const newSubscriptions = [];

      if (!subscribed.includes(globalTopic) && !subscribed.includes(postsTopic)) {
        subscribeToFCMByBackend(FCMToken, [globalTopic, postsTopic]);
        newSubscriptions.push(globalTopic);
        newSubscriptions.push(postsTopic);
      }

      if (!subscribed.includes(globalTopic)) {
        subscribeToFCMByBackend(FCMToken, [globalTopic]);
        newSubscriptions.push(globalTopic);
      }

      if (!subscribed.includes(postsTopic)) {
        subscribeToFCMByBackend(FCMToken, [postsTopic]);
        newSubscriptions.push(postsTopic);
      }

      if (newSubscriptions.length > 0) {
        const updated = Array.from(new Set([...subscribed, ...newSubscriptions]));
        localStorage.setItem('subscribedTopics', JSON.stringify(updated));
        console.log("✅ Topics souscrits :", updated);
      }

    } catch (err) {
      console.error("❌ Erreur lors de la souscription aux topics :", err);
    }
  }
};

async function refreshFCMToken() {

  // delete current token
  // localStorage.removeItem("FCMToken");
  // localStorage.removeItem("subscribedTopics");

  // if (!messaging) return;

  // await deleteToken(messaging);
  await getToken(messaging, {
      vapidKey: "BHqJdAGSoWPcD0_z-zCYJYhrGnYOCvQVUbDm5-Eh-qaeyXH51loH0FaSDsxgp8X0LyaFcRTjSToyxPCfwqroeyg"
    }).then((currentToken) => {
      if (currentToken) {
        // console.log("Token FCM :", currentToken);
        localStorage.setItem("FCMToken", currentToken);
        subscribeToTopics();
      } else {
        console.log("Aucun token dispo. Permission pas encore donnée ?");
      }
    }).catch((err) => {
      console.error("Erreur pour récupérer le token :", err);
  });
}

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  refreshFCMToken();
} else if (isWindowApp) {
  // setTimeout(refreshFCMToken, 2000);
  // alert(localStorage.getItem("FCMToken"));
}

// onMessage(messaging, (payload) => {
//   console.log("Notification reçue en foreground :", payload);
//   if (payload.data.type == "post") {
//     const postCount = localStorage.getItem("post");
//     localStorage.setItem("post", (parseInt(postCount) + 1).toString());
//   }
//   // localStorage.setItem(payload);
  
//   // {from: '999831171054', collapseKey: 'campaign_collapse_key_1053923347005225011', messageId: '296dcb95-4b19-4833-a12c-7a5e9f3d6691', notification: {…}, data: {…}}
//   // collapseKey: "campaign_collapse_key_1053923347005225011"
//   // data: {gcm.n.e: '1', google.c.a.ts: '1744073570', google.c.a.udt: '0', google.c.a.c_id: '1053923347005225011', gcm.notification.sound2: 'default', …}
//   // from: "999831171054"
//   // messageId: "296dcb95-4b19-4833-a12c-7a5e9f3d6691"
//   // notification: {title: 'TITLE', body: 'TEXT'}
//   // [[Prototype]]: Object
// });

export default function App() {
  const { newVersionAvailable, setNewVersionAvailable, updateApp } = useUpdateNotifier();

  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    // ReactGA.send("pageview"); // Envoie un événement lors du chargement de la page

    // Update serviceWorker
    // if ('serviceWorker' in navigator) {
    //   let refreshing = false;
    //   navigator.serviceWorker.addEventListener('controllerchange', () => {
    //     if (refreshing) return;
    //     window.location.reload();
    //     refreshing = true;
    //   });
    // }
    // if ('serviceWorker' in navigator) {
    // USE THIS WHEN NOT HTTPS OR LOCALHOST
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(reg => {
          // console.log('SW registered: ', reg);
    
          reg.onupdatefound = () => {
            const newWorker = reg.installing;
            newWorker.onstatechange = () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Une nouvelle version est dispo
                newWorker.postMessage({ action: 'skipWaiting' });
              }
            };
          };
        });
      });
    // }

      // 👂 Écoute les messages du service worker
      navigator.serviceWorker.addEventListener("message", (event) => {
        // console.log('allo', event.data);
        if (event.data?.type === "NEW_NOTIFICATION") {
          const notif = event.data.payload;
          // console.log("📩 Nouvelle notif :", notif);
    
          // 🔐 Lis les anciennes notifications
          const stored = localStorage.getItem("notifications");
          const notifs = stored ? JSON.parse(stored) : [];
    
          // 📝 Ajoute la nouvelle
          notifs.unshift({
            title: notif.title,
            body: notif.body,
            data: notif.data,
            timestamp: new Date().toISOString()
          });
    
          // 💾 Sauvegarde
          localStorage.setItem("notifications", JSON.stringify(notifs));
          // localStorage.removeItem("notifications");
          // localStorage.clear();
          // const removeTopic = (topic: string) => {
          //   let raw = localStorage.getItem("subscribedTopics");

          //   if (raw) {
          //     let array = JSON.parse(raw);

          //     let newArray = array.filter((item: string) => item !== topic);

          //     // 5. Sauvegarder de nouveau
          //     localStorage.setItem("subscribedTopics", JSON.stringify(newArray));
          //   }
          // }
        }
      });
    }
  }, []);
 

  // const {user, userId} = useAuthContext();
  // const [client , setClient] = useState(null)

  // useEffect(() => {
  //   getUser()
  // } ,[user])

  // const getUser = async () => {
  //   if (user) {
  //     await axios({
  //         method: "GET",
  //         url:"/api/graphql/user/"+ userId,
  //       }).then((response)=>{
  //         const data = response.data;
  //         setClient(data);
  //       }).catch((error) => {
  //         if (error.response) {
  //           console.log(error.response);
  //           console.log(error.response.status);
  //           console.log(error.response.headers);
  //           }
  //     });
  //   }
  // }

  // return (
  //   <BrowserRouter>
  //     <Routes>
  //         <Route index element={<Home />} />
  //     </Routes>
  //   </BrowserRouter>
  // )

  return (
    <>
      <BrowserRouter>
      {/* <Router> */}
        <AnalyticsTracker />
        <Routes>
          {/* ERRORS */}
          <Route path="*" element={<NotFound />} />
          <Route path="/error/400" element={<Error400 />} />
          <Route path="/error/403" element={<ForbiddenError />} />
          <Route path="/error/500" element={<ServerError />} />
          {/* TERMS OF USE */}
          <Route path="/terms_of_use" element={<Terms />} />
          {/* <Route index element={<Home />} /> */}

          {/* 🔴 Route protégée qui ne doit PAS avoir de Layout */}
          {/* MOBILE */}
          <Route element={<ProtectedRoute allowedTypes={['MANAGER']} redirectPath="/" />}>
            <Route path="schedulerManager" element={<SchedulerMobileView />} />
            <Route path="openSchedulerManager" element={<OpenSchedulerMobileView />} />
          </Route>

          {/* 🔵 Un seul Layout englobe tout ce qui en a besoin */}
          <Route path="/" element={<Layout direction={""} />}>  
            <Route index element={<Home />} />
            <Route path="details" element={<DetailView />} />
            {/* <Route path="testing" element={<Home />} /> */}
            <Route path="news" element={<Blog />} />
            <Route path="actualites" element={<Blog />} />

            <Route path="help" element={<Help />} />
            <Route path="aide" element={<Help />} />

            <Route path="signin" element={<SignIn />} />
            {/* <Route path="connection" element={<SignIn />} /> */} 

            <Route path="signup" element={<SignUp />} />
            <Route path="inscription" element={<SignUp />} />

            <Route path="confirmEmail" element={<ConfirmEmail />} />
            <Route path="confirmationCourriel" element={<ConfirmEmail />} />
            
            <Route path="forgotPassword" element={<ForgotPassword />} />
            <Route path="newPassword" element={<NewPassword />} />
            <Route path="suspended" element={<Suspended />} />
            <Route path="company_suspended" element={<CompanySuspended />} />

            {/* Routes protégées */}
            <Route element={<ProtectedRoute allowedTypes={['MANAGER']} redirectPath="/" />}>
              <Route path="/company/:id" element={<CompanyView />} />
              <Route path="/compagnie/:id" element={<CompanyView />} />
              {/* SPREADSHEETS */}
              <Route path="table/shift" element={<Table />} />
              <Route path="table/quart" element={<Table />} />
              <Route path="excel_import/shift" element={<ExcelImport />} />
              <Route path="importation_excel/quart" element={<ExcelImport />} />
              <Route path="table/open_shift" element={<TableOpenShift />} />
              <Route path="table/quart_public" element={<TableOpenShift />} />
              <Route path="excel_import/open_shift" element={<ExcelImportOpenShift />} />
              <Route path="importation_excel/quart_public" element={<ExcelImportOpenShift />} />
              {/* SCHEDULER & AGENDA */}
              <Route path="scheduler" element={<SchedulerView />} />
              <Route path="planificateur" element={<SchedulerView />} />
              <Route path="scheduler/open_shifts" element={<OpenSchedulerView />} />
              <Route path="planificateur/quarts_publics" element={<OpenSchedulerView />} />
              <Route path="agenda/management" element={<AgendaManagerView />} />
              <Route path="agenda/gestion" element={<AgendaManagerView />} />
              <Route path="add/workers" element={<CreateWorkers />} />
              <Route path="ajouter/travailleurs" element={<CreateWorkers />} />
              {/* PAYMENT */}
              {/* <Route path="billing" element={<BraintreeBillingView />} /> */}
              <Route path="billing" element={<BillingView />} />
              <Route path="facturation" element={<BillingView />} />
              <Route path="subscribe/:type" element={<StripeBillingView />} />
              <Route path="subscription/success" element={<StripeSuccessView />} />
              <Route path="subscription/cancel" element={<StripeCancelView />} />
              <Route path="billing/free_plan" element={<FreePlanView />} />
              {/* DOCUMENT */}
              <Route path='documents' element={<DocumentsView />} />
              <Route path='worker/:id/documents' element={<DocumentByWorkerScreen />} />
              <Route path='travailleur/:id/documents' element={<DocumentByWorkerScreen />} />
              {/* REQUEST */}
              <Route path='requests/management/swaps' element={<RequestSwapsView />} />
              <Route path='requetes/gestion/transferts' element={<RequestSwapsView />} />
              <Route path='requests/management/leaves' element={<RequestLeavesView />} /> 
              <Route path='requetes/gestion/conges' element={<RequestLeavesView />} />
            </Route>

            <Route element={<ProtectedRoute allowedTypes={['MANAGER', 'EMPLOYEE']} redirectPath="/" />}>
              {/* USER */}
              <Route path="dashboard" element={<DashboardView />} />
              <Route path="tableau_de_bord" element={<DashboardView />} />
              <Route path="settings" element={<ProfileView />} />
              <Route path="parametres" element={<ProfileView />} />
              <Route path="profile/edit" element={<EditProfileView />} />
              <Route path="profile/modification" element={<EditProfileView />} />

              <Route path="users" element={<UsersView />} />
              <Route path="utilisateurs" element={<UsersView />} />

              <Route path='user/:id' element={<UserView />} />
              <Route path='utilisateur/:id' element={<UserView />} />
              {/* SHIFT & OPENSHIFT */}
              {/* <Route path='open_shifts' element={<OpenShiftsByUserView />} /> */}
              {/* <Route path='open_shifts/public' element={<OpenPublicShiftsByUserView />} /> */}
              <Route path='open_shifts' element={<OpenPublicShiftsByUserView />} />
              <Route path='quarts_publics' element={<OpenPublicShiftsByUserView />} />
              <Route path='shifts' element={<ShiftsByUserView />} />
              <Route path='quarts' element={<ShiftsByUserView />} />

              <Route path='shift/:id' element={<ShiftView />} /> 
              <Route path='quart/:id' element={<ShiftView />} /> 
              <Route path='shift/:id/coworkers' element={<UsersByShiftsView />} />
              <Route path='quart/:id/collegues' element={<UsersByShiftsView />} />
              <Route path="agenda" element={<AgendaView />} />
              {/* COMPANY */}
              <Route path="create/company" element={<CreateCompanyView />} /> 
              <Route path="creation/compagnie" element={<CreateCompanyView />} />
              {/* POST */}
              <Route path="posts" element={<PostsView />} />
              <Route path="messages" element={<PostsView />} />
              <Route path="posts/:id" element={<PostsByUserView />} />
              <Route path="messages/:id" element={<PostsByUserView />} />
              {/* DOCUMENT */}
              <Route path='worker/documents' element={<UserDocumentsView />} />
              <Route path='travailleur/documents' element={<UserDocumentsView />} />
              {/* REQUEST */}
              <Route path='requests/swap/create/shift/:id' element={<CreateRequestSwapView />} />
              <Route path='requetes/transferts/creation/quart/:id' element={<CreateRequestSwapView />} />
              <Route path='requests/swaps' element={<RequestUserSwapsView />} />
              <Route path='requetes/transferts' element={<RequestUserSwapsView />} />
              <Route path='suggestedUser/requests/swaps' element={<RequestSuggestedUserSwapsView />} />
              <Route path='utilisateurSuggere/requetes/transferts' element={<RequestSuggestedUserSwapsView />} />
              <Route path='requests/leave/create' element={<CreateLeaveRequestSwapsView />} />
              <Route path='requetes/conge/creation' element={<CreateLeaveRequestSwapsView />} />
              <Route path='requests/leaves' element={<RequestSuggestedUserLeavesView />} />
              <Route path='requetes/conges' element={<RequestSuggestedUserLeavesView />} />
              {/* PUNCH */}
              <Route path='map/:id' element={<MapView />} />
              <Route path='carte/:id' element={<MapView />} />
            </Route>
          </Route>
        </Routes>
        {/* </Router> */}
      </BrowserRouter>

      {/* service worker update */}
      {/* <ToastContainer position="bottom-center" className="mb-3">
        <Toast show={newVersionAvailable} bg="info" onClose={() => setNewVersionAvailable(false)}>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">🔄 Mise à jour disponible</strong>
            <Button
              variant="outline-light"
              size="sm"
              className="ms-auto"
              onClick={() => setNewVersionAvailable(false)}
            >
              ✕
            </Button>
          </Toast.Header>
          <Toast.Body>
            Une nouvelle version est prête.
            <div className="mt-2 text-end d-flex gap-2 justify-content-end">
              <Button variant="light" size="sm" onClick={updateApp}>
                Rafraîchir maintenant
              </Button>
              <Button variant="outline-light" size="sm" onClick={() => setNewVersionAvailable(false)}>
                Fermer
              </Button>
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer> */}
    </>
  );
}